var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingbased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1001 7.99977C8.1001 8.84846 8.43724 9.66238 9.03735 10.2625C9.63746 10.8626 10.4514 11.1997 11.3001 11.1997C12.1487 11.1997 12.9627 10.8626 13.5628 10.2625C14.1629 9.66238 14.5 8.84846 14.5 7.99977C14.5 7.15109 14.1629 6.33716 13.5628 5.73705C12.9627 5.13694 12.1487 4.7998 11.3001 4.7998C10.4514 4.7998 9.63746 5.13694 9.03735 5.73705C8.43724 6.33716 8.1001 7.15109 8.1001 7.99977Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.1994V17.5994C6.5 16.7507 6.83714 15.9368 7.43725 15.3367C8.03736 14.7366 8.85128 14.3994 9.69997 14.3994H12.8999",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 17.599L15.3002 19.199L18.5001 15.999",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingbased);
export default __webpack_public_path__ + "static/media/meetingbased.cedfd3ee4be7b6e4502c8309ce7e4663.svg";
export { ForwardRef as ReactComponent };